
/* injects from baggage-loader */
require('./balance-to-maturity.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('balanceToMaturity', {
    templateUrl: '/app/components/deal-sheet/contract/balance-to-maturity.component.html',
    bindings: {
        value: '<'
    }
});
